import { Language } from "@/components/Inputs/LanguagePicker/Language.ts";
import { useIsCroatian } from "@/helpers/translation/useIsCroatian.ts";
import { Extra, MandatoryExtra } from "@/helpers/types/types.ts";
import { getLocale } from "@/stores/ApolloClient/helpers/getLocale.ts";
import { useTranslation } from "react-i18next";

/**
 * Retrieves translated information for an Extra entity
 * Default App language is "hr"
 *     - if it's hr return directly the entity values
 *     - if it's not hr, check if there is a translation for the current language and return it,
 *       if not return the entity values
 * Returns an object containing the translated information
 */
export const useGetExtrasTranslated = () => {
  const { i18n } = useTranslation();

  const isCroatian = useIsCroatian();

  return (extra: Extra | MandatoryExtra) => {
    const translation = extra.translations?.find((t) => t.language === getLocale(i18n.language as Language));
    const name = isCroatian ? extra.name : translation?.name || extra.name;
    const description = isCroatian ? extra.description : translation?.description || extra.description;

    return { translation, name, description };
  };
};
